import * as React from 'react';
import { ILogFilter } from '../common/defaults';
import Form from 'react-bootstrap/Form';
import { Row, Col, Button, Card } from 'react-bootstrap';
import AuditLogFilterControl from './AuditLogFilterControl';

const $ = require('jquery');

export interface IAuditLogFiltersProps {
  logtypename: string;
  filters: ILogFilter[];
  onFilter?: (filterValues: any) => void;
}

interface AuditLogFiltersLocalState {
  filterValues: any;
  controlQueries: any;
  filterQuery: any;
}

export default class AuditLogFilters extends React.Component<
  IAuditLogFiltersProps,
  AuditLogFiltersLocalState
> {
  constructor(props) {
    super(props);
    this.state = {
      filterValues: {},
      filterQuery: {},
      controlQueries: {}
    };
  }
  componentDidMount() {
    if (this.state.filterQuery && this.state.filterQuery.length > 0) {
      this.props.onFilter(this.state.filterQuery);
    }
  }

  setValue(logpropertyname: string, query: any) {
    let newQueries = this.state.controlQueries;
    newQueries = { ...newQueries, [logpropertyname]: query };
    this.setState({ controlQueries: newQueries }, () => {
      this.makeQuery(logpropertyname === 'created_date');
    });
  }

  makeQuery(executeFilterNow: boolean = false): any {
    let mustQuery = [];
    Object.keys(this.state.controlQueries).forEach(item => {
      if(this.state.controlQueries[item].range || 
        (this.state.controlQueries[item].query_string && 
        !this.isEmptyOrSpaces(this.state.controlQueries[item].query_string.query)))
      {
        mustQuery.push(this.state.controlQueries[item]);
      }
    });
    
    this.setState(
      {
        filterQuery: mustQuery
      },
      () => {
        if (executeFilterNow) {
          this.props.onFilter(this.state.filterQuery);
        }
      }
    );
  };
  
  isEmptyOrSpaces(str): boolean {
    try {
      return str === null || str.match(/^ *$/) !== null;
    } catch {
      return false;
    }
  };

  public render() {
    return (
      <React.Fragment>
        <Form>
          <Form.Row>
            {this.props.filters.map(filter => (
              <Form.Group
                key={filter.logpropertyname}
                as={Col}
                controlId={filter.logpropertyname}
              >
                <Form.Label>{filter.name}</Form.Label>
                <AuditLogFilterControl
                  logtypename={this.props.logtypename}
                  datatype={filter.datatype}
                  logpropertyname={filter.logpropertyname}
                  filterName={filter.name}
                  onChange={(a, b) => this.setValue(a, b)}
                />
              </Form.Group>
            ))}
          </Form.Row>
          <Button
            variant="primary"
            onClick={e => this.props.onFilter(this.state.filterQuery)}
          >
            Apply Filters
          </Button>
        </Form>
      </React.Fragment>
    );
  }
}
